import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setLayers, clearLayers } from "../../../store/actions/layerActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAllLayers = (bearerAuth) => {
  return async dispatch => {
    API.get("/api/portal/layers")
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setLayers(response.body));
        } else if (response.status === 401) {
          dispatch(clearLayers);
          dispatch(authLogout);
        } else {
          dispatch(clearLayers)
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Layer Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearLayers);
      })
  }
}
